import { Link } from 'react-router-dom'
import { Box, Stack } from '@mui/material'
import logo from 'img/menu_logo.png'


const NetamotoLogo = () => {
    return (
        <Stack
            component={Link}
            to="/"
            alignItems="center"
            sx={{
                '&:hover' : {
                    opacity : 0.5,
                },
            }}
        >
            <Box
                component="img"
                src={logo}
                sx={{ width: { xs: 60, md: 94 } }}
            />
        </Stack>
    )
}

export default NetamotoLogo
